import { createContext, useContext } from 'react';

import { AppSettingFields } from 'common/appSettings/appSettings.model';

export const AppSettingContext = createContext<AppSettingFields | undefined | null>(undefined);

export const useAppSettings = () => {
  return useContext(AppSettingContext);
};
